module.exports = __webpack_public_path__ + "static/media/bolso (9).e0368bcb.jpg";